import { axios, Response } from '../index'

const blockOperatorAccessById = (operatorId: string): Response<null> => {
  return axios.delete(`/v1/operators/${operatorId}/profiles`)
}

export default blockOperatorAccessById
